import { Component } from 'react';
import ReactDOM from 'react-dom';

export default class Portal extends Component {
  constructor() {
    super();

    /* global __isBrowser__:true */
    if (__isBrowser__) {
      this.el = document.createElement('div');
      this.portalRoot = document.getElementById('portal');
    }
  }

  componentDidMount() {
    this.portalRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    this.portalRoot.removeChild(this.el);
  }

  render() {
    const { children } = this.props;
    return ReactDOM.createPortal(children, this.el);
  }
}
